export default __webpack_public_path__ + "static/media/icon-copy-blue.49025b63.svg";